"use strict";

exports.__esModule = true;

function test(expression) {
  var messages = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    messages[_i - 1] = arguments[_i];
  }

  if (expression) return false; // Default message

  if (messages.length === 0) messages.push('console.assert');
  return {
    method: 'error',
    data: ["Assertion failed:"].concat(messages)
  };
}

exports.test = test;